import { memo } from "react";
import LOGO from "src/images/logo.png";
const Header = ({ style = {} }) => {
  return (
    <header style={style}>
      <img src={LOGO} alt="orders.co" />
      <p id="siteUrl"></p>
    </header>
  );
};

export default memo(Header);
